import React from 'react';
import { useSortable } from '@dnd-kit/react/sortable';
import { MsComboBox } from '../../../../components/MsComboBox';
import { ToggleSwitch } from '../../../../components/ToggleSwitch';
import type { RelativityField, RelativitySettingsField } from '../../../../types/relativitySettings';

interface Props {
  field: RelativitySettingsField;
  index: number;
  relativityFields: RelativityField[];
  saving: boolean;
  onChange: (f: RelativitySettingsField) => void;
}

export function FieldMappingRow({ field, index, relativityFields, saving, onChange }: Props) {
  const { ref, isDragging } = useSortable({
    id: field.name || `field-${index}`,
    index,
  });

  return (
    <tr ref={ref} style={{ opacity: isDragging ? 0.4 : 1 }}>
      <td style={{ verticalAlign: 'middle', textAlign: 'center', cursor: 'move', width: 24 }}>
        <i className="fas fa-bars fa-fw" style={{ color: '#aaa' }} />
      </td>
      <td>
        <MsComboBox<RelativityField>
          selected={field.outputName ? relativityFields.filter(rf => rf.name === field.outputName) : []}
          onChange={items => onChange({ ...field, outputName: items.slice(-1)[0]?.name ?? null })}
          getKey={rf => rf.name}
          getLabel={rf => rf.name}
          items={relativityFields}
          disabled={saving || field.name === 'Identifier'}
        />
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} className="medium">
          {field.name}
        </div>
      </td>
      <td style={{ verticalAlign: 'middle', whiteSpace: 'nowrap', width: 1 }}>
        <ToggleSwitch
          checked={field.isEnabled}
          onChange={isEnabled => onChange({ ...field, isEnabled })}
          onLabel="ON"
          offLabel="OFF"
          size="small"
        />
      </td>
    </tr>
  );
}
